import { useTheme } from '@emotion/react'
import { Chip } from '@mui/material'
import { CandidateRecruitingStatus } from 'shared/models/candidateRecruitingStatus'

const RecruitingStatusPill = ({
    status,
    showLabel,
    sx,
}: {
    status: CandidateRecruitingStatus
    showLabel?: boolean
    sx?: React.CSSProperties
}) => {
    const theme = useTheme()
    const backgroundColor = (() => {
        switch (status) {
            case 'Final Stages':
            case 'Actively Recruiting':
                return theme.palette.status.blue
            case 'Opportunistic':
                return theme.palette.status.purple
            case 'Holding Out':
                return theme.palette.status.pink
            case 'Not Recruiting':
                return theme.palette.status.orange
            case 'Do Not Call':
                return theme.palette.status.red
            case 'No Status':
            default:
                return theme.palette.status.grey
        }
    })()

    const displayStatus = status ?? 'No Status'

    return (
        <Chip
            title="Recruiting Status"
            size="small"
            label={showLabel ? `Recruiting: ${displayStatus}` : displayStatus}
            sx={{
                backgroundColor,
                color: theme.palette.greyscale.white,
                ...sx,
            }}
        />
    )
}

export default RecruitingStatusPill
